import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, createContext, useContext, useState } from "react";
import api from "../services/api";
import { jwtDecode } from "jwt-decode";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    
    const location = useLocation();
    const navigate = useNavigate();

    const [userData, setUserData] = useState(null);
    const [token, setToken] = useState(() => localStorage.getItem("token")); // ✅

    const logout = () => {
        
        localStorage.removeItem("token");
        setToken(null);
        setUserData(null);
        navigate("/");

    };

    const validateAuthToken = async () => {
        
        try {
            await api.get("/authToken"); // ✅ interceptor manda Bearer do localStorage
            return true;
        } catch (error) {
            return false;
        }
    };

    useEffect(() => {
        
        // Se estiver na página de login, não força redireciono
        if (location.pathname === "/") return;

        if (!token) {
            navigate("/");
            return;
        }

        // Decodifica com segurança
        try {
            const decoded = jwtDecode(token);
            setUserData(decoded);
        } catch {
            logout();
            return;
        }

        // Valida no backend
        (async () => {
            const ok = await validateAuthToken();
            if (!ok) logout();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, token]);

    const values = { logout, userData, token, setToken };

    return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
